import React, { useEffect } from "react";
import { useAuth } from "../contexts/AuthProvider";
import { Button } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";

interface IOwnProps {
  title: string;
  body: React.ReactElement;
  addButtonHandler?: () => void;
  showSearchBtn?: boolean;
}

export const PageContainer: React.FC<IOwnProps> = ({ title, body, addButtonHandler, showSearchBtn = false }: IOwnProps) => {
  const { setPageTitle, setShowSearchBtn } = useAuth();
  useEffect(() => {
    setPageTitle(title);
  }, [title]);

  useEffect(() => {
    setShowSearchBtn(showSearchBtn);
  }, [showSearchBtn]);
  return <div className="pb-4">
    {addButtonHandler && (<Button
      variant='danger'
      className="position-fixed bottom-0 end-0 m-4 p-2 rounded-circle z-3 bg-purple"
      onClick={addButtonHandler}
    >
      <Plus size={36} />
    </Button>
    )}
    {body}
  </div>;
};
